import styled from 'styled-components';
import HeaderInformation from '../../../../HeaderInformation';

const StyledCompanyInfo = styled(HeaderInformation)`
  padding: 24px 0;
`;

export {StyledCompanyInfo};
